var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    name: 'announcementWindow',
    computed: __assign({}, mapState('common', {
        isOpenAnnouncement: 'isOpenAnnouncement',
        announcement: 'announcement',
    }), { content: function () {
            var content = this.announcement.content;
            return content ? content.split('\n') : '';
        } }),
    data: function () {
        return {
            data: {
                title: '弹窗标题最长可不超过十五个字哈',
            },
        };
    },
    methods: {
        closeWindow: function () {
            this.$store.commit('common/update', { isOpenAnnouncement: false });
        },
    },
});
